import { toast, ToastContainer, ToastContentProps, Zoom } from "react-toastify";
import { Fragment } from "react";
import messageExceptionCaster from "../message-exception-caster";
import T from "./text/Text";

type ToastData = { title: string; message?: string };

function ToastElement(props: ToastContentProps<ToastData>) {
  const { data } = props;

  return (
    <div>
      <T style="bold">{data.title}</T>
      {data.message ? (
        <Fragment>
          <br />
          <T>{data.message}</T>
        </Fragment>
      ) : null}
    </div>
  );
}

function success(title: string, message?: string) {
  toast.info<ToastData>(ToastElement, {
    data: { title, message },
    toastId: `${title}${message}`,
    transition: Zoom,
  });
}

function fromError(error: unknown) {
  const casted = messageExceptionCaster.cast(error);
  toast.error(ToastElement, {
    data: { title: "Erreur", message: casted.message },
    transition: Zoom,
  });
}

export function Toasts() {
  return <ToastContainer />;
}

const Toasting = { success, fromError };

export default Toasting;
